import React from "react";
import { useDispatch } from "react-redux";
import "../RoleName/RoleName.css";
import "../OptionBlocks.css";
import {
  BalanceOff,
  BalanceCenter,
  ColumnHorizontal,
  ColumnVertical,
  GutterAlignment,
  JustifiedAlignment3,
  LeftAlignment2,
  RaggedAlignment,
  RightAlignment2,
  SideAB,
  InsetOff,
  InsetLeft,
  InsetRight,
  SingleColumnCenter,
  SingleColumnLeft,
  SingleColumnRight,
} from "../../../../../assets/icons/index";
import { NumberInput, Radio } from "../../../../../Components";
import {
  updateProjectCreditOptionsState,
  saveOptionById,
} from "../../../../../Redux/actions/projectActions";

import { LineHeight } from "../../../../ProjectV2/Options/OptionFont/Functions";
import HeadingDisclosure from "../HeadingDisclosure";
import LayoutDisclosure from "../LayoutDisclosure";
import ColumnWidthPresets from "../ColumnWidthPresets";
import { useLocation } from "react-router-dom";
const Blurb = ({ options, currentBlockIdx, currentBlockId, isCard }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const handleChange = (key, val) => {
    dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, val, true));
  };

  const saveOptions = () => dispatch(saveOptionById(currentBlockId, isCard));

  const getValue = (value) => {
    return value ? value : "";
  };
  return (
    <div className="Roles-name">
      <div className="rolename-inside">
        <HeadingDisclosure
          heading={getValue(options?.heading)}
          subheading={getValue(options?.subheading)}
          onChange={handleChange}
          onFocusOut={saveOptions}
        />
        <LayoutDisclosure title="Structure">
        <div className="optionSection">
          <div className="optionSectionLabel  inline-block group  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Text Alignment</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the visual spacing and dividing lines between roles and
              names.
            </span>
          </div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: SingleColumnCenter, value: "center" },
                { icon: SingleColumnLeft, value: "left" },
                { icon: SingleColumnRight, value: "right" },
                { icon: JustifiedAlignment3, value: "justify", disabled: true },
                { icon: GutterAlignment, value: "gutter", disabled: true },
              ]}
              value={options.text_alignment}
              onChange={(val) => {
                handleChange("text_alignment", val);
                saveOptions();
              }}
              label={options.text_alignment}
              withIcon
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Block Inset</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal indentation and padding of the block.
            </span>
          </div>
          <div className="optionSectionContent BLock-inset BLock-inset-nameonly">
            <Radio
              label={options.block_inset}
              options={[
                {
                  icon: InsetOff,
                  value: "default",
                  disabled:
                    options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" ||
                      options?.block_inset === "right"),
                },
                {
                  icon: InsetLeft,
                  value: "left",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: InsetRight,
                  value: "right",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: SideAB,
                  value: "sidebyside",
                  disabled: options?.side_by_side === "on",
                },
              ]}
              value={options.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>
        </LayoutDisclosure>

        <LayoutDisclosure title="Spacing">
        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Width</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal width of the credit block as a percentage.
            </span>
          </div>
          <div className="optionSectionContent columnWidthControls">
            <ColumnWidthPresets
              value={Number(options.column_width) || 100}
              minWidth={20}
              maxWidth={100}
              onChange={(value) => {
                handleChange("column_width", value);
                saveOptions();
              }}
            />
            <NumberInput
              postLabel="%"
              value={Number(options.column_width) || 100}
              onChange={(val) => handleChange("column_width", val)}
              min={20}
              max={100}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        {/* <div className="optionSection">
          <div className="optionSectionContent2">
            <Radio
              options={[
                { icon: BalanceOff, value: null },
                { icon: BalanceCenter, value: "center" },
              ]}
              value={options.balance_columns}
              onChange={(val) => {
                handleChange("balance_columns", val);
                saveOptions();
              }}
              withIcon
              label="Balance"
            />
          </div>
        </div> */}
        {/* <div className="optionSection">
          <div className="optionSectionLabel">Order</div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: ColumnHorizontal, value: "horizontal" },
                { icon: ColumnVertical, value: "vertical" },
              ]}
              value={options.column_flow}
              onChange={(val) => {
                handleChange("column_flow", val);
                saveOptions();
              }}
              label="Column flow"
              withIcon
            />
          </div>
        </div> */}
        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Line Height</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the vertical spacing between lines of credit text.
            </span>
          </div>
          <div className="optionSectionContent">
            <LineHeight
              styleKey="blurb"
              currentBlockType={options?.block_type || "blurb"}
              currentBlockId={currentBlockId}
              currentBlockIdx={currentBlockIdx}
              isCard={isCard}
            />
          </div>
        </div>

        {!isCard && (
          <div>
            <div className="optionSection">
              <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                <span className="cursor-help">Margin</span>
                <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                  Adjust the vertical margin around the credit block.
                </span>
              </div>
              <div className="optionSectionContent block-option-content">
                <div className="label-2 label-2-roleName1440">Vertical</div>
                <NumberInput
                  value={options?.margin_vertical ?? 0}
                  min={0}
                  max={50}
                  step={10}
                  postLabel="%"
                  onChange={(val) => handleChange("margin_vertical", val)}
                  onFocusOut={saveOptions}
                />
              </div>
            </div>

            <div className="optionSection">
              <div className="optionSectionContent2 block-option-content">
                <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                  <span className="cursor-help">Bottom</span>
                  <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                    Adjust the extra spacing directly below the credit block.
                  </span>
                </div>
                <NumberInput
                  // label="Bottom"
                  value={options.extra_lines_below}
                  min={0}
                  max={25}
                  onChange={(val) => handleChange("extra_lines_below", val)}
                  onFocusOut={saveOptions}
                />
              </div>
            </div>
          </div>
        )}
        {isCard && <div></div>}
        </LayoutDisclosure>
      </div>
    </div>
  );
};

export default Blurb;
